import React, { useMemo } from 'react';

import { Box, Img } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { Contest } from 'models';
import { formatDuration } from 'utils/formatDuration';

const NextContestCountAsDescription: React.FC<{ data: Contest }> = ({ data }) => {
  const now = dayjs().tz('America/Los_Angeles');
  const startsAtNewYork = dayjs(data.startsAt).tz('America/Los_Angeles');
  const startdDiff = startsAtNewYork.diff(now);
  const durationUntilLocks = dayjs.duration(startdDiff);
  const startTime = formatDuration(durationUntilLocks);

  return (
    <Box
      // bg="#F83C3C"
      // p="8px 0 12px"
      // pos="absolute"
      bottom="0"
      left="0"
      right="0"
      overflow="hidden"
      textAlign="center"
      margin="0 -12px"
    >
      <Box mt="4px" fontSize="14px" fontWeight="700" lineHeight="16.8px">
        Next round {parseInt(startTime) < 0 ? 'opens soon' : `in ${startTime}`}
      </Box>
    </Box>
  );
};

export default NextContestCountAsDescription;
